import { render } from "./template.vue?vue&type=template&id=1d782780"
const script = {}

import "./template.vue?vue&type=style&index=0&id=1d782780&lang=scss"

import exportComponent from "/home/circleci/app-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__